"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.postOrganizationsByAdminEmail = exports.getOrganizationsSummaries = exports.getOrganizationsByEccEndUserId = exports.getOrganizationsByClaimedDomain = exports.getOrganizationsByContractId = exports.getOrganizationsByAdminId = exports.getOrganizationsByTokenizedName = exports.getOrganizationsByName = exports.getOrganizationsByIMSOrgId = void 0;
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2022 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

const isNil_1 = __importDefault(require("lodash/isNil"));

const omitBy_1 = __importDefault(require("lodash/omitBy"));

const getOrganizationsByIMSOrgId = (jilFetch, options) => {
  const path = `organizations/${options.orgId}`;
  const params = omitBy_1.default({
    include_ancestors: options.includeAncestors,
    include_dx_tenant: options.includeDxTenant
  }, isNil_1.default);
  return jilFetch(path, params, {
    headers: {
      'Accept-Language': options.acceptLanguage
    },
    method: 'GET'
  });
};

exports.getOrganizationsByIMSOrgId = getOrganizationsByIMSOrgId;

const getOrganizationsByName = (jilFetch, options) => {
  const path = 'organizations%3Asearch.name';
  const params = omitBy_1.default({
    include_ancestors: options.includeAncestors,
    include_dx_tenant: options.includeDxTenant,
    name: options.name,
    org_type: options.orgType,
    page: options.page,
    page_size: options.pageSize,
    sort_order: options.sortOrder
  }, isNil_1.default);
  return jilFetch(path, params, {
    headers: {
      'Accept-Language': options.acceptLanguage
    },
    method: 'GET'
  });
};

exports.getOrganizationsByName = getOrganizationsByName;

const getOrganizationsByTokenizedName = (jilFetch, options) => {
  const path = 'organizations%3Asearch.tokenized_name';
  const params = omitBy_1.default({
    include_ancestors: options.includeAncestors,
    include_dx_tenant: options.includeDxTenant,
    org_type: options.orgType,
    page: options.page,
    page_size: options.pageSize,
    sort_order: options.sortOrder,
    tokenized_name: options.tokenizedName
  }, isNil_1.default);
  return jilFetch(path, params, {
    headers: {
      'Accept-Language': options.acceptLanguage
    },
    method: 'GET'
  });
};

exports.getOrganizationsByTokenizedName = getOrganizationsByTokenizedName;

const getOrganizationsByAdminId = (jilFetch, options) => {
  const path = 'organizations%3Asearch.admin_id';
  const params = omitBy_1.default({
    admin_id: options.adminId,
    include_ancestors: options.includeAncestors,
    include_dx_tenant: options.includeDxTenant,
    org_type: options.orgType,
    page: options.page,
    page_size: options.pageSize,
    sort_order: options.sortOrder
  }, isNil_1.default);
  return jilFetch(path, params, {
    headers: {
      'Accept-Language': options.acceptLanguage
    },
    method: 'GET'
  });
};

exports.getOrganizationsByAdminId = getOrganizationsByAdminId;

const getOrganizationsByContractId = (jilFetch, options) => {
  const path = 'organizations%3Asearch.contract';
  const params = omitBy_1.default({
    id: options.id,
    include_ancestors: options.includeAncestors,
    include_dx_tenant: options.includeDxTenant,
    org_type: options.orgType,
    page: options.page,
    page_size: options.pageSize,
    sort_order: options.sortOrder
  }, isNil_1.default);
  return jilFetch(path, params, {
    headers: {
      'Accept-Language': options.acceptLanguage
    },
    method: 'GET'
  });
};

exports.getOrganizationsByContractId = getOrganizationsByContractId;

const getOrganizationsByClaimedDomain = (jilFetch, options) => {
  const path = 'organizations%3Asearch.claimed_domain';
  const params = omitBy_1.default({
    claimed_domain: options.claimedDomain,
    include_ancestors: options.includeAncestors,
    include_dx_tenant: options.includeDxTenant,
    org_type: options.orgType,
    page: options.page,
    page_size: options.pageSize,
    sort_order: options.sortOrder
  }, isNil_1.default);
  return jilFetch(path, params, {
    headers: {
      'Accept-Language': options.acceptLanguage
    },
    method: 'GET'
  });
};

exports.getOrganizationsByClaimedDomain = getOrganizationsByClaimedDomain;

const getOrganizationsByEccEndUserId = (jilFetch, options) => {
  const path = 'organizations%3Asearch.ecc_end_user_id';
  const params = omitBy_1.default({
    ecc_end_user_id: options.eccEndUserId,
    include_ancestors: options.includeAncestors,
    include_dx_tenant: options.includeDxTenant,
    org_type: options.orgType,
    page: options.page,
    page_size: options.pageSize,
    sort_order: options.sortOrder
  }, isNil_1.default);
  return jilFetch(path, params, {
    headers: {
      'Accept-Language': options.acceptLanguage
    },
    method: 'GET'
  });
};

exports.getOrganizationsByEccEndUserId = getOrganizationsByEccEndUserId;

const getOrganizationsSummaries = (jilFetch, options) => {
  const path = 'organizations%3Asummaries';
  const params = omitBy_1.default({
    orgIds: options.orgIds.join(',')
  }, isNil_1.default);
  return jilFetch(path, params, {
    headers: {
      'Accept-Language': options.acceptLanguage
    },
    method: 'GET'
  });
};

exports.getOrganizationsSummaries = getOrganizationsSummaries;

const postOrganizationsByAdminEmail = (jilFetch, options) => {
  const path = 'organizations%3Asearch.admin_email';
  const params = omitBy_1.default({
    include_ancestors: options.includeAncestors,
    include_dx_tenant: options.includeDxTenant,
    org_type: options.orgType,
    sort_order: options.sortOrder
  }, isNil_1.default);
  const data = new URLSearchParams();
  data.append('admin_email', options.formParams.adminEmail);

  if (options.formParams.page) {
    data.append('page', options.formParams.page.toString());
  }

  if (options.formParams.pageSize) {
    data.append('page_size', options.formParams.pageSize.toString());
  }

  return jilFetch(path, params, {
    body: data,
    headers: {
      'Accept-Language': options.acceptLanguage,
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    method: 'POST'
  });
};

exports.postOrganizationsByAdminEmail = postOrganizationsByAdminEmail;